import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
const original = Router.prototype.push;

Router.prototype.push = function push(location) {
  return original.call(this, location).catch((err) => err);
};

Vue.use(Router);

import index from "../pages/index";

export const constantRouterMap = [
  {
    path: "/",
    component: index,
    children: [
      {
        path: ":type?",
        component: () => import("../pages/index/_type"),
      },
    ],
  },
  {
    path: "/views/operateVideo",
    name: "operateVideo",
    component: () => import("../pages/operateVideo"),
  },
  {
    path: "/more/more",
    component: () => import("../pages/more"),
  },
  {
    path: "/views/:type/:viewname/:name?",
    component: () => import("../pages/views/_type/_viewname/_name"),
  },
  {
    path: "/static/register",
    component: () => import("../pages/Register"),
  },
  {
    path: "/views/personalCenter",
    name: "personalCenter",
    component: () => import("../pages/personalCenter"),
  },
  {
    path: "/views/forget",
    component: () => import("../pages/forget"),
  },
];

const router = new Router({
  mode: "history", //后端支持可开
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: constantRouterMap,
});
router.afterEach((to, from) => {
  const path = to.fullPath.split("/");
  let item;
  if (path.length === 2) {
    item = path[1];
    switch (item) {
      case "index":
        document.title = "首页";
        break;
      case "gsgg":
        document.title = "公司公告";
        break;
      case "xwbd":
        document.title = "新闻报道";
        break;
      case "yjbg":
        document.title = "研究报告";
        break;
      case "gsjg":
        document.title = "公司研究";
        break;
      case "qtwb":
        document.title = "综合文本";
        break;
      default:
        document.title = "爱文本-智能文本分析系统";
        break;
    }
  }
  if (path.length === 5) {
    item = path[2];
    const datebase = path[3];
    let module;
    let db = "";
    switch (item) {
      case "index":
        document.title = "首页";
        break;
      case "gsgg":
        module = "公司公告";
        break;
      case "xwbd":
        module = "新闻报道";
        break;
      case "yjbg":
        module = "研究报告";
        break;
      case "gsjg":
        module = "公司研究";
        break;
      case "qtwb":
        module = "综合文本";
        break;
      default:
        module = "爱文本-智能文本分析系统";
    }
    //定时访问vuex，有数据在进行下一步
    var timer = setInterval(() => {
      if (store.state.SystemList.hasOwnProperty(datebase)) {
        db = store.state.SystemList[datebase].name;
        document.title = db + " - " + module;
        clearInterval(timer);
      }
    }, 100);
  }
});
export default router;
